import React from "react";
import { MaterialDesignIcons } from "../styled";

export const PublishMIcon: React.FC<{ fontSize: string }> = ({ fontSize }) => {
  return <MaterialDesignIcons fontSize={fontSize}>publish</MaterialDesignIcons>;
};
